import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function JourneyTile({ journey, delay = 0 }) {
  return (
    <Reveal delay={delay}>
      <Link
        to={`/journeys/${journey.slug}`}
        data-testid={`journey-tile-${journey.slug}`}
        className="group block"
      >
        <div className="overflow-hidden rounded-2xl">
          <img
            src={journey.image.src}
            alt={journey.image.alt}
            loading="lazy"
            style={{ objectPosition: journey.image.tilePosition || journey.image.position || "center" }}
            className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          />
        </div>
        <p className="mt-7 text-sm font-semibold uppercase tracking-[0.22em] text-[#7C6E33]">
          {journey.destination}
        </p>
        <h3 className="mt-2 text-2xl font-medium tracking-tight sm:text-3xl">{journey.title}</h3>
        <p className="mt-3 max-w-md font-serif italic text-lg leading-relaxed text-ink/70">
          {journey.positioning}
        </p>
        <span className="mt-5 inline-flex items-center gap-2 text-base font-medium text-pine">
          Explore this journey
          <ArrowRight
            className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
            aria-hidden="true"
          />
        </span>
      </Link>
    </Reveal>
  );
}
